import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
// TodayView is the landing route — needed on virtually every cold entry, so it
// ships in the main bundle (NOT lazy) and renders directly with the shell.
// No <Suspense> wraps it: it's local-first (SQLite reads resolve in ~50ms) and
// hydrates synchronously from the TanStack cache, so a fallback would only
// flash + cause a remount. All its queries are non-suspending.
import { TodayView } from "@/features/habits/components/today-view";

/** Main product screen: TODAY's habits. */
function TodayPage() {
  return <TodayView />;
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  // `day` focuses the carousel on a specific day (interconnection from the
  // Calendar heatmap: tap a day → its habits). Absent → today.
  // `note` (#15b) opens the day note dialog for that habit on focused
  // day → `/?day=<d>&note=<habitId>` is copyable/reloadable.
  validateSearch: (search: Record<string, unknown>): { day?: string; note?: string } => ({
    day: typeof search.day === "string" ? search.day : undefined,
    note: typeof search.note === "string" && search.note.trim() !== "" ? search.note : undefined,
  }),
  component: TodayPage,
});
